import { Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import { NgwWowService } from 'ngx-wow';
import {
  Router,
  Event,
  NavigationStart,
  NavigationEnd,
  NavigationError,
} from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  languageList = [
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Francais' },
  ];
  ngOnInit() {
    const analytics = firebase.analytics();
    analytics.logEvent('website_visit');
  }
  constructor(
    private wowService: NgwWowService,
    private router: Router,
    @Inject(LOCALE_ID) protected localeId: string,
    private translate: TranslateService
  ) {
    translate.setDefaultLang('en');
    this.wowService.init();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.router.events.subscribe((event) => {
          $.getScript('assets/js/main.js');
        });
      }
      if (event instanceof NavigationEnd) {
      }
      if (event instanceof NavigationError) {
      }
    });
  }
}
